<template>
  <!-- Sending... -->
  <div class="flies-step sending-flies">
    <div class="d-flex align-items-center mb-2">
      <a
        href="javascript:void(0)"
        data-toggle="modal"
        class="d-inline-block mr-3"
        @click="cancelReceive()"
      >
        <i class="icon-img icon-ms img-outline-close mt-1"></i>
      </a>
      <div>
        <h5 class="mb-1">Receiving...</h5>
      </div>
    </div>
    <div class="sending-cont">
      <div class="text-center py-3">
        <div>
          <img src="images/transmore.png" alt="" width="80px" />
        </div>
        <h6 class="my-2">From {{ receiveClientName }}</h6>
      </div>
      <div class="py-2">
        <div class="progress mb-2">
          <div
            class="progress-bar"
            role="progressbar"
            :style="'width: ' + progress + '%;'"
            :aria-valuenow="progress"
            aria-valuemin="0"
            aria-valuemax="100"
          >
            <span>{{ progress }}%</span>
          </div>
        </div>
        <div class="d-flex justify-content-between small">
          <span>Total {{ filesInfo.total_num }} files</span>
          <span>
            <strong class="text-primary">
              {{ fileLengthFormat(uploadedSize + uploadingSize) }}
            </strong>
            / {{ fileLengthFormat(filesInfo.total_size) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "../../../utils/Request";
import OSS from "ali-oss";
import JSZip from "jszip";
import { fileLengthFormat, stringToHex } from "../../../utils/Helpers";
import { saveAs } from "file-saver";

export default {
  name: "MyReceiving",
  data() {
    return {
      isLoading: false,
      transferAjax: null,
      uploadedSize: 0,
      uploadingSize: 0,
      oss: {
        region: "",
        accessKeyId: "",
        accessKeySecret: "",
        bucket: "",
        expire: ""
      },
      client: null,
      zip: null,
      currentIndex: 0,
      canReportProgress: true
    };
  },
  model: {
    prop: "transfer"
  },
  props: {
    transfer: Object
  },
  computed: {
    filesInfo() {
      // 这里计算属性直接返回filesInfo，而不是filesInfo下的属性是因为total_size和total_num的改变无法触发更新事件
      return this.transfer.filesInfo;
    },
    receiveClientName() {
      return this.transfer.upload_client_name;
    },
    progress() {
      return parseInt(
        ((this.uploadedSize + this.uploadingSize) / this.filesInfo.total_size) *
          100
      );
    }
  },
  watch: {
    uploadingSize() {
      if (!this.canReportProgress) {
        return;
      }
      this.canReportProgress = false;
      request({
        baseURL: this.transfer.host_url,
        url: "update-status",
        method: "get",
        withCredentials: false,
        params: {
          keycode: this.transfer.transfer_key,
          progress: (
            (this.uploadedSize + this.uploadingSize) /
            this.filesInfo.total_size
          ).toFixed(2)
        }
      }).then(() => {
        let _self = this;
        setTimeout(function() {
          _self.canReportProgress = true;
        }, 1000);
      });
    }
  },
  created() {
    if (this.transfer.is_lan === 1) {
      // 局域网传输，先设置状态
      request({
        baseURL: this.transfer.host_url,
        url: "update-status",
        method: "get",
        withCredentials: false,
        params: {
          keycode: this.transfer.transfer_key,
          status: 1,
          receive_client_name: stringToHex(this.$store.getters.nickname)
        }
      }).then(() => {
        // 状态设置成功后开始下载文件
        this.zip = new JSZip();
        this.downloadInLAN();
      });
      return;
    }
    // 关于网传输，等待文件上传成功后再开始下载
    this.waiting();
  },
  methods: {
    fileLengthFormat(size) {
      return fileLengthFormat(size);
    },
    waiting() {
      let _self = this;
      if (_self.isLoading || _self.transfer.step !== 5) {
        return;
      }
      _self.isLoading = true;
      request({
        url: "/v1/transfer/get-status",
        data: {
          transfer_type: 1,
          id: _self.transfer.id
        }
      })
        .then(response => {
          if (response.code === 204101) {
            this.transfer.step = 1;
            return;
          }

          if (response.code === 200) {
            if (response.data.status === 3) {
              this.zip = new JSZip();
              this.beginReceive();
              return;
            }
            if (response.data.status > 3) {
              this.transfer.step = 6;
              this.transfer.status = response.data.status;
            }
          }

          setTimeout(function() {
            _self.waiting();
          }, 2000);
        })
        .finally(() => {
          _self.isLoading = false;
        });
    },
    beginReceive() {
      request({
        url: "/v1/aliyun/sts"
      }).then(response => {
        if (response.StatusCode === 200) {
          this.oss.region = response.Endpoint;
          this.oss.accessKeyId = response.AccessKeyId;
          this.oss.accessKeySecret = response.AccessKeySecret;
          this.oss.bucket = response.Bucket;
          this.oss.expire = response.Expiration;
          this.oss.stsToken = response.SecurityToken;
          this.client = new OSS({
            endpoint: this.oss.region,
            accessKeyId: this.oss.accessKeyId,
            accessKeySecret: this.oss.accessKeySecret,
            stsToken: this.oss.stsToken,
            bucket: this.oss.bucket
          });
          this.downloadFile();
        }
      });
    },
    downloadFile() {
      // 判断oss sts过期时间
      if (
        new Date().getTime() >
        new Date(this.oss.expire).getTime() - 1000 * 30
      ) {
        this.beginReceive();
        return;
      }
      let _self = this;
      let url = _self.client.signatureUrl(
        _self.transfer.object_prefix +
          "/" +
          _self.transfer.files[_self.currentIndex].key,
        { expires: 3600 }
      );
      _self.downloadRequest(url);
    },
    downloadInLAN() {
      let url =
        this.transfer.host_url +
        "get-file?keycode=" +
        this.transfer.transfer_key +
        "&filekey=" +
        this.transfer.files[this.currentIndex].key +
        "&filepath=" +
        stringToHex(this.transfer.files[this.currentIndex].name);
      this.downloadRequest(url);
    },
    downloadRequest(url) {
      let _self = this;
      try {
        _self.transferAjax = new XMLHttpRequest();
        _self.transferAjax.open("get", url, true);
        //监听进度事件
        _self.transferAjax.addEventListener(
          "progress",
          function(evt) {
            if (_self.transfer.step !== 5) {
              _self.transferAjax.abort();
              return;
            }
            if (evt.lengthComputable) {
              _self.uploadingSize = evt.loaded;
            }
          },
          false
        );

        _self.transferAjax.responseType = "blob";
        _self.transferAjax.onreadystatechange = function() {
          if (_self.transferAjax.readyState === 4) {
            if (_self.transferAjax.status === 200) {
              _self.zip.file(
                _self.getFilename(
                  _self.transfer.files[_self.currentIndex].name
                ),
                _self.transferAjax.response
              );
              if (_self.transfer.is_lan === 1) {
                // 局域网更新单个文件下载状态
                request({
                  baseURL: _self.transfer.host_url,
                  url: "update-status",
                  method: "get",
                  withCredentials: false,
                  params: {
                    keycode: _self.transfer.transfer_key,
                    status: 1,
                    filekey: _self.transfer.files[_self.currentIndex].key,
                    filepath: stringToHex(
                      _self.transfer.files[_self.currentIndex].name
                    )
                  }
                });
              }

              _self.uploadedSize += parseInt(
                _self.transfer.files[_self.currentIndex].size
              );
              _self.uploadingSize = 0;
              _self.currentIndex++;
              if (_self.currentIndex < _self.transfer.total_num) {
                if (_self.transfer.is_lan === 1) {
                  _self.downloadInLAN();
                } else {
                  _self.downloadFile();
                }
              } else {
                if (_self.transfer.is_lan === 1) {
                  // 局域网通知APP端下载完成
                  request({
                    baseURL: _self.transfer.host_url,
                    url: "update-status",
                    method: "get",
                    withCredentials: false,
                    params: {
                      keycode: _self.transfer.transfer_key,
                      status: 6
                    }
                  });
                }
                // 向服务器更新这次传输任务的状态
                request({
                  url: "/v1/transfer/set-status",
                  data: {
                    transfer_type: 1,
                    id: _self.transfer.id,
                    status: 6
                  }
                });
                // 保存文件并跳转页面
                _self.zip
                  .generateAsync({ type: "blob" })
                  .then(function(content) {
                    saveAs(
                      content,
                      "TransMore-" + new Date().getTime() + ".zip"
                    );
                    _self.transfer.status = 6;
                    _self.transfer.step = 6;
                  });
              }
            } else {
              if (_self.transfer.step != 6) {
                _self.transfer.step = 6;
                _self.transfer.status = 5;
              }
            }
          }
        };
        _self.transferAjax.send();
      } catch (e) {
        // 捕获超时异常
        if (e.code === "ConnectionTimeoutError") {
          console.log("Timeout");
        } else {
          console.log(e);
        }
      }
    },
    /**
     * 获取路径中的文件名
     * @param path
     * @returns {*|string}
     */
    getFilename(path) {
      let arr = path.split("/");
      return arr[arr.length - 1];
    },
    cancelReceive() {
      this.transfer.step = 6;
      this.transfer.status = 8;
    }
  }
};
</script>
